export { default as BuyCourse } from './buy-course';
export * from './course-contents/module-lesson';
export { default as FirstSection } from './first-section';
export { default as Statistics } from './first-section/statistics';
export * from './main'
export * from './payment'
